VjsAdmin.GroupBulkUploadValidate = (function () {
    const init = function () {
        $('#bulk-uploads-groups').on('click', '.bulk-upload-group-row.selectable', function () {
            const groupname = $(this).attr('data-group-name');
            $(this).find('input[type=radio]').prop('checked', true);
            $(`#bulk-uploads-groups > tbody > tr[data-group-name=${groupname}]`).removeClass('selected not-selected');
            $(this).addClass('selected');
            $(`#bulk-uploads-groups > tbody > tr[data-group-name=${groupname}]`).not(this).addClass('not-selected');
            const numToSelect = $('#queue-button').attr('data-number-of-existing-groups');
            const numSelected = $('#bulk-uploads-groups input[type=radio]:checked').length;
            $('#queue-button').prop('disabled', !(+numToSelect === +numSelected));
        });
    };

    return {
        init,
    };
}());
